export { default as GDMCollapse } from './GDMCollapse';

export type { GDMCollapseComponent, GDMCollapseProps } from './GDMCollapse.type';
